module.exports = __webpack_public_path__ + "static/media/rv4.cf7e0bf7.jpg";